import { useMemo } from 'react';
import { useQuery } from 'react-query';
import isEmpty from 'lodash/isEmpty';
import ResidentService from '../../services/residentService';

/**
 * Open-cert state of a resident's household, including whether any open cert
 * is locked, via ResidentService.getOpenCertsLockInfo.
 *
 * The key sits under the 'hasOpenCerts' prefix so the prefix invalidations
 * fired when a certification completes or is cancelled also refresh it.
 */
const useOpenCertsLockInfoQuery = ({
  organizationId,
  propertyId,
  residentId,
  options = {},
}: {
  organizationId: string,
  propertyId: string,
  residentId: string,
  options?: { enabled?: boolean },
}) => {
  const residentService = useMemo(() => new ResidentService(), []);

  return useQuery(
    ['hasOpenCerts', 'lockInfo', organizationId, propertyId, residentId],
    () =>
      residentService.getOpenCertsLockInfo(
        organizationId,
        propertyId,
        residentId,
      ),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      enabled:
        !isEmpty(organizationId ?? '') &&
        !isEmpty(propertyId ?? '') &&
        !isEmpty(residentId ?? '') &&
        options.enabled !== false,
    },
  );
};

export default useOpenCertsLockInfoQuery;
